import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/simplybuilt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M481.2 64c14.7 0 26.5 11.8 26.7 26.3v331.4c0 14.5-11.8 26.3-26.6 26.3h-450.4c-14.8 0-26.6-11.8-26.6-26.3v-331.4c0-14.5 11.8-26.3 26.4-26.3h106c14.6 0 26.6 11.8 26.6 26.3v39.6h185.3v-39.6c0-14.5 12.1-26.3 26.6-26.3h106zM149.8 355.8c36.9 0 66.6-29.7 66.6-66.4 0-36.9-29.7-66.6-66.6-66.6-36.7 0-66.4 29.7-66.4 66.6 0 36.7 29.8 66.4 66.4 66.4zM362.2 355.8c36.6 0 66.4-29.7 66.4-66.6 0-36.7-29.8-66.4-66.4-66.4-36.9 0-66.6 29.8-66.6 66.4 0 36.9 29.7 66.6 66.6 66.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/simplybuilt.js
// module id = 1013
// module chunks = 0